module.exports = "../images/icons/close-white.svg";